<script lang="ts">
	import { afterNavigate } from "$app/navigation";
	import Vic from "src/components/vic.svelte";
	import {
		GetGroupFlagsByTeamIdDoc,
		GetGroupFlagsByTeamIdQuery,
		Groups_Flags_Enum,
		InsertActionVisit,
	} from "src/graphql-operations";

	import userStore from "src/stores/user";
	import { query } from "svelte-apollo";
	let vicEnabled = false;
	let userId: string;
	let userToken: string;

	afterNavigate(async (nav) => {
		if (
			(await userStore.isAuthenticated()) &&
			userStore.getSelectedProjectId()
		) {
			const teamId = userStore.getSelectedProjectId();
			userId = (await userStore.getAuth0User()).sub;

			InsertActionVisit({
				variables: {
					user_id: userId,
					team_id: teamId,
					at_page_slug: nav.to.url.pathname,
					previous_page_slug: nav.from?.url?.pathname ?? undefined,
				},
			});
			userStore.setAlternativeCanvas(teamId);

			const flags = await query<GetGroupFlagsByTeamIdQuery>(
				GetGroupFlagsByTeamIdDoc,
				{
					variables: { team_id: teamId },
				},
			).result();

			if (
				flags.data.groups_group_flags
					.map((g) => g.flag)
					.includes(Groups_Flags_Enum.VicTest)
			) {
				vicEnabled = true;
				userToken = await userStore.getAccessToken();
			}
		}
	});
</script>

<div
	class="relative h-full min-h-screen bg-[#f4f5f5] text-gray-brand-500"
	data-sveltekit-preload-data="hover"
>
	<slot />
	{#if vicEnabled}
		<Vic token={userToken} />
	{/if}
</div>
